<template>
  <div class="video-container">
    <div class="video-wrapper">
      <video ref="videoPlayer" class="video-player" @click="playPauseVideo()" :poster="poster.url" :autoplay="autoplay" controls width="1920" height="1080">
        <template v-for="video in videoSources">
          <source :src="video.url" :type="`video/${video.format}`">
        </template>
        Your browser does not support HTML5 video.
      </video>
        
    </div>
    <svg v-if="!videoIsPlaying" @click="playPauseVideo()" class="video-play-button" viewBox="0 0 200 200" alt="Play video">
      <circle cx="100" cy="100" r="90" fill="none" stroke-width="15" stroke="#fff"/>
      <polygon points="70, 55 70, 145 145, 100" fill="#fff"/>
    </svg>
    <a v-if="!videoIsPlaying" href="#video-article" class="v-more"><span></span>read more</a>
  </div>
</template>

<script>
export default {
  name: 'content-video',
  props: ['video'],
  data () {
    return {
      videoIsPlaying: this.video.primary.autoplay === 'Yes'
    }
  },
  computed: {
    poster () {
      if (this.video.primary.placeholder) {
        return {
          url: this.video.primary.placeholder.url,
          alt: this.video.primary.placeholder.alt,
          width: this.video.primary.placeholder.width,
          height: this.video.primary.placeholder.height
        }
      }
    },
    videoSources () {
      return this.video.items ? this.video.items : null
    },
    autoplay () {
      return this.video.primary.autoplay === 'Yes'
    }
  },
  methods: {
    playPauseVideo () {
      let videoPlayer = this.$refs.videoPlayer
      if (videoPlayer.paused) {
        videoPlayer.play()
        this.videoIsPlaying = true
      } else {
        videoPlayer.pause()
        this.videoIsPlaying = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video-container {
  position: relative;
  max-height: 100vh;
  margin: 0 auto 3rem;

  @media (min-width: $breakpoint-lg) {
    margin-left: $nav-button-width;
  }
}

.v-more {
  padding-top: 60px;
  position: absolute;
  bottom: 4rem;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  color: $dark-blue;
  text-decoration: none;
  transition: opacity .3s;
  font-family: $font-heading;
} 

.v-more:hover {
  opacity: .5;
} 

.v-more span {
  position: absolute;
  top: 0;
  left: 50%;
  width: 46px;
  height: 46px;
  margin-left: -23px;
  border: 2px solid rgba($dark-blue,.5);
  border-radius: 100%;
  box-sizing: border-box;
}
.v-more span::after {
  position: absolute;
  top: 50%;
  left: 50%;
  content: '';
  width: 16px;
  height: 16px;
  margin: -12px 0 0 -8px;
  border-left: 1px solid $dark-blue;
  border-bottom: 1px solid $dark-blue;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  box-sizing: border-box;
}

.video-wrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;
  margin: -1rem auto 0rem;
  max-height: 100vh;
}

.video-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-height: 100vh;
}

.video-play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100px;
  z-index: 1;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// Video.vue?436adb70